import { get } from 'lodash-es';
import { FREE_CODE } from 'site-modules/shared/components/delivery/constants';

const DELIVERY_TEXT = 'Delivery or Express Pickup';

export function getDeliveryText({ vinData }) {
  const deliveryOptions = get(vinData, 'computedDisplayInfo.deliveryOptions');
  const deliveryCode = get(deliveryOptions, 'deliveryCode');

  return deliveryCode === FREE_CODE ? `Free ${DELIVERY_TEXT}` : DELIVERY_TEXT;
}
